"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderTimeSlot = void 0;
var DateCheck_1 = require("../Dates/DateCheck");
var getOrderTimeSlot = function (order) {
    var _a, _b;
    return (0, DateCheck_1.isNextPotagerWeek)(order === null || order === void 0 ? void 0 : order.date)
        ? (_a = order === null || order === void 0 ? void 0 : order.groupDeliveryDay) === null || _a === void 0 ? void 0 : _a.timeSlot
        : (_b = order === null || order === void 0 ? void 0 : order.groupDeliveryDay) === null || _b === void 0 ? void 0 : _b.currentWeekTimeSlot;
};
exports.getOrderTimeSlot = getOrderTimeSlot;
exports.default = { getOrderTimeSlot: exports.getOrderTimeSlot };
//# sourceMappingURL=OrderTimeSlot.js.map